import { Severity } from 'Data/ViewModels/Core/Severity';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './Components/App';
import store from './Data/Redux';
import webApi from './Lib/WebApi/index';
import * as serviceWorker from './Lib/serviceWorker';
import './Styles/styles.scss';

// Special global variables
declare global {
  interface Window {
    qest: {
      userAgent?: string;
      isFrame?: boolean;
      webApi?: any;
      /**
       * Indicates whether the QEST Web App is busy (i.e. saving data)
       * to prevent navigation in QESTLab/QESTField
       *
       * We store this globally so we can access this in a fixed callback function
       */
      isBusy?: boolean;
      /**
       * Allows QESTField to issue a notification within the QEST Web App
       */
      notify?: (message: string, severity: Severity, additionalDetails: string) => void;
    };
    /**
     * JS extern provided in WebKitX browser to register a callback function
     *
     * Will be undefined in other browsers
     *
     * See https://www.webkitx.com/doc/light/WebKitX%20JavaScript%20Externs~-.-~register.html
     */
    register?: (functionName: string, callbackFunction: any, thisContext?: object) => any;
    /**
     * JS extern provided in WebKitX browser to unregister a callback function.
     * Calling with no function name will unregister all callbacks.
     *
     * Will be undefined in other browsers
     *
     * Not officially released. Provided to us in a hotfix.
     */
    unregister?: (functionName?: string) => any;
    /**
     * Allow QWA to access QESTField functions, currently use to call QF.refreshLogin method
     * after login through QWA success
     *
     * Will be undefined in other browsers
     */
    QP?: any;
  }
}

if (!window.qest) window.qest = {};
window.qest.userAgent = navigator.userAgent;
window.qest.isFrame = navigator.userAgent.includes('[QL]');
if (process.env.NODE_ENV === 'development') {
  window.qest.webApi = webApi;
}
window.qest.isBusy = false;

//if is iframe, initialize
if (!window.QP) window.QP = {};

const root = createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
